import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { doSettingPageClose } from 'store/actions';

import { ChecksListScreen } from './ChecksListScreen';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.SETTINGS],
  Screens.SettingsAssessmentCompliance
>;

export const SettingsAssessmentCompliance: React.FC<Props> = ({
  navigation,
}) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      dispatch(doSettingPageClose());
    };
  }, [dispatch]);

  return <ChecksListScreen navigation={navigation} />;
};
